import AccountingInfoOption from './AccountingInfoOption';

export default class FinancialSector extends AccountingInfoOption {
    public static entity = 'financialSectors';
    public static apiType = 'financial-sectors';
    public static storageKey = 'financial_sectors_list';
}